import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { formatDate } from "../../helpers/globalfunctions.js";
import { axiosPost } from "../../apis/useAxios.js";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DateFormat } from "../../helpers/fixcodes.js";
import moment from "moment";
import ImageViewerComponent from "../Shared/ImageViewerComponent.jsx";
import { SelectBox } from "devextreme-react";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];
export class FeedbackComponent extends Component {
  static displayName = FeedbackComponent.name;
  constructor(props) {
    super(props);
    this.state = {
      selectedTabId: this.props?.location?.state?.selectedTabId ?? 1,
      dropdownCrewDataSource: [],
      hotelFeedbackGridDataSource: [],
      transportFeedbackGridDataSource: [],
      employeeNumber: this.props?.location?.state?.employeeNumber ?? "",
      searchFromDate:
        this.props?.location?.state?.searchFromDate ??
        moment(new Date()).add(-30, "days").toDate(),
      searchToDate: this.props?.location?.state?.searchToDate ?? new Date(),

      isShowImagePopup: false,
      imagePopup: {
        imageViewerTitle: "",
        imageFileUrls: [],
      },
    };
    this.refHotelGrid = React.createRef();
    this.refTransportGrid = React.createRef();
    this.refDateRangePicker = React.createRef();
    this.isComponentDidMounted = false;
  }
  applyDateRangePreset = (preset) => {
    try {
      const [start, end] = preset.getRange();
      this.setState({
        searchFromDate: start.toDate(),
        searchToDate: end.toDate(),
      });
      if (this.refDateRangePicker.current) {
        this.refDateRangePicker.current.setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  isDateRangePresetActive = (preset) => {
    const [start, end] = preset.getRange();
    return (
      this.state.searchFromDate &&
      this.state.searchToDate &&
      start.isSame(this.state.searchFromDate, "day") &&
      end.isSame(this.state.searchToDate, "day")
    );
  };
  renderDateRangeCalendarContainer = ({ className, children }) => {
    return (
      <CalendarContainer className={className}>
        <div className="dc-daterange-shell">
          <div className="dc-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`dc-preset-btn${
                  this.isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => this.applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="dc-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    );
  };
  async componentDidMount() {
    if (this.isComponentDidMounted) {
      return;
    }
    document.querySelector("#lblPageTitle").innerHTML =
      "Crew Feedback Comment and Reply";
    this.FetchFeedbackData();
    this.isComponentDidMounted = true;
  }
  FetchFeedbackData = () => {
    try {
      setTimeout(async () => {
        await this.GetHotelFeedback();
      }, 0);
      setTimeout(async () => {
        await this.GetTransportFeedback();
      }, 0);
      setTimeout(async () => {
        await this.getAirlineCrewDropdownData();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  getAirlineCrewDropdownData = async () => {
    try {
      const response = await axiosPost("Crew/GetAllCrew", {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
        Status: "",
      });

      let airlineCrew = [
        ...new Set(
          response?.payload?.map((item) => {
            return {
              employeeNumber: item.employeeNumber,
              employeeName: `${item.employeeNumber} - ${item.firstName} ${item.lastName}`,
            };
          }),
        ),
      ];

      this.setState({
        dropdownCrewDataSource: airlineCrew,
      });
    } catch (error) {
      console.log(
        "Error in " + this.displayName + ".getDropdownData function",
        error,
      );
    } finally {
      this.setState({ loadPanelVisible: false });
    }
  };
  GetHotelFeedback = async () => {
    try {
      this.refHotelGrid.current.instance.beginCustomLoading();

      let airlineCode = sessionStorage.getItem("session_airlineCode");

      let request = {};
      request.AirlineCode = airlineCode;
      request.FromDate = formatDate(this.state.searchFromDate, "yyyy-MM-dd");
      request.ToDate = formatDate(
        this.state.searchToDate ?? this.state.searchFromDate,
        "yyyy-MM-dd",
      );
      request.EmployeeNumber = this.state.employeeNumber;
      request.UserMasterId = 1;

      const response = await axiosPost("Feedback/get-hotel-transport", request);

      this.setState((prev) => ({
        ...prev,
        hotelFeedbackGridDataSource: response?.payload ?? [],
      }));

      this.refHotelGrid.current.instance.repaint();
      this.refHotelGrid.current.instance.refresh();
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".GetHotelFeedback function",
        err,
      );
    } finally {
      this.refHotelGrid.current.instance.endCustomLoading();
    }
  };
  GetTransportFeedback = async () => {
    try {
      this.refTransportGrid.current.instance.beginCustomLoading();

      let airlineCode = sessionStorage.getItem("session_airlineCode");

      let request = {};
      request.AirlineCode = airlineCode;
      request.FromDate = formatDate(this.state.searchFromDate, "yyyy-MM-dd");
      request.ToDate = formatDate(
        this.state.searchToDate ?? this.state.searchFromDate,
        "yyyy-MM-dd",
      );
      request.EmployeeNumber = this.state.employeeNumber;
      request.UserMasterId = 1;

      const response = await axiosPost("Feedback/get-local-transport", request);

      this.setState((prev) => ({
        ...prev,
        transportFeedbackGridDataSource: response?.payload ?? [],
      }));

      this.refTransportGrid.current.instance.repaint();
      this.refTransportGrid.current.instance.refresh();
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".GetTransportFeedback function",
        err,
      );
    } finally {
      this.refTransportGrid.current.instance.endCustomLoading();
    }
  };
  handleSearchFeedback = (e) => {
    e.preventDefault();
    try {
      this.FetchFeedbackData();
    } catch (error) {
      console.log(error);
    }
  };
  handleOnCloseImagePopup = () => {
    this.setState((prev) => ({
      ...prev,
      isShowImagePopup: false,
      imagePopup: {
        imageViewerTitle: "",
        imageFileUrls: [],
      },
    }));
  };
  handleOnRedirectToComment = (e, data) => {
    e.preventDefault();
    try {
      this.props.history.push({
        pathname: "/feedback/comment",
        state: {
          feedbackId: data.id,
          feedbackType: this.state.selectedTabId,
          searchFromDate: this.state.searchFromDate,
          searchToDate: this.state.searchToDate,
          selectedTabId: this.state.selectedTabId,
          employeeNumber: this.state.employeeNumber,
          sourceUrl: "/feedback",
        },
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  handleOnImagePopupClose = () => {
    this.setState((prev) => ({
      ...prev,
      isShowImagePopup: false,
      imagePopup: {
        imageViewerTitle: "",
        imageFileUrls: [],
      },
    }));
  };
  render() {
    return (
      <>
        <style>{`
          /* ── Feedback — theme matching sidebar #8E6448 ── */
          .ca-filter-card {
            border: 1px solid #e8d5c4 !important;
            background: #fdf7f2 !important;
          }
          .ca-filter-body {
            padding: 0.75rem 1rem 0.5rem 1rem;
          }
          .ca-filter-body label {
            font-size: 0.72rem !important;
            font-weight: 700 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            color: #7a4f2e !important;
            margin-bottom: 3px !important;
          }
          .ca-filter-body .quick-links a {
            font-size: 0.76rem;
            color: #8E6448;
            font-weight: 600;
            text-decoration: none;
          }
          .ca-filter-body .quick-links a:hover { text-decoration: underline; }
          .dc-daterange-field {
            flex: 0 0 176px;
            min-width: 176px;
          }
          .dc-daterange-wrapper {
            display: block;
            width: 100%;
          }
          .dc-daterange-input {
            display: block;
            width: 100%;
            border: 1px solid #e3d5c6;
            border-radius: 6px;
            background: #fffdfb;
            padding: 5px 9px;
            min-height: 31px;
            font-size: 0.8rem;
            color: #333;
            box-sizing: border-box;
            outline: none;
            transition: border-color 0.15s ease;
          }
          .dc-daterange-input:hover {
            border-color: #d9c3aa;
          }
          .dc-daterange-input:focus {
            border-color: #f4691e;
            box-shadow: none;
          }
          .react-datepicker-popper {
            z-index: 1050;
          }
          .react-datepicker__day--in-range,
          .react-datepicker__day--in-selecting-range,
          .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--keyboard-selected {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--range-start,
          .react-datepicker__day--range-end,
          .react-datepicker__day--selecting-range-start,
          .react-datepicker__day--selecting-range-end,
          .react-datepicker__day--selected {
            background-color: #f4691e;
            color: #ffffff;
          }
          .react-datepicker__header {
            background-color: #fdf7f2;
            border-bottom: 1px solid #e8d5c4;
          }
          .dc-daterange-shell {
            display: flex;
            align-items: stretch;
          }
          .dc-daterange-presets {
            display: flex;
            flex-direction: column;
            gap: 2px;
            padding: 8px 6px;
            background: #fdf7f2;
            border-right: 1px solid #e8d5c4;
            min-width: 112px;
          }
          .dc-preset-btn {
            border: none;
            background: transparent;
            text-align: left;
            padding: 6px 10px;
            font-size: 0.78rem;
            font-weight: 600;
            color: #6b4a2b;
            border-radius: 5px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-preset-btn:hover {
            background: #f5e7d8;
          }
          .dc-preset-btn.active {
            background: #f4691e;
            color: #ffffff;
          }
          .dc-daterange-months {
            position: relative;
          }
          .leads-date-range-popover {
            position: absolute;
            top: 100%;
            left: 0;
            z-index: 9999;
            margin-top: 8px;
          }
          .feedback-date-range-button {
            background: #f8f3ed !important;
            border: 1px solid #e0d0c4 !important;
            color: #8E6448 !important;
            font-weight: 500 !important;
            font-size: 13px !important;
            padding: 6px 12px !important;
            border-radius: 6px !important;
            transition: all 0.2s ease !important;
            width: 100%;
            text-align: left;
          }
          .feedback-date-range-button:hover {
            background: #f0e5da !important;
            border-color: #d4c5b9 !important;
          }
          .rdrDateRangeWrapper {
            background: #ffffff !important;
            border-radius: 12px !important;
            box-shadow: 0 4px 24px rgba(142,100,72,0.15) !important;
            border: 1px solid #e8d5c4 !important;
            padding: 20px !important;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          }
          .rdrInputSeries {
            gap: 12px !important;
          }
          .rdrInputWrapper {
            background: #f8f3ed !important;
            border-radius: 8px !important;
            border: 1px solid #e0d0c4 !important;
            padding: 10px !important;
          }
          .rdrInputWrapper input {
            background: transparent !important;
            border: none !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #333333 !important;
          }
          .rdrMonth {
            width: 100% !important;
          }
          .rdrMonths {
            padding: 0 !important;
          }
          .rdrMonthName,
          .rdrCaption {
            color: #8E6448 !important;
            font-weight: 600 !important;
          }
          .rdrWeekday {
            color: #8E6448 !important;
            font-weight: 600 !important;
            font-size: 12px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.5px !important;
          }
          .rdrDay {
            font-size: 14px !important;
            color: #333333 !important;
          }
          .rdrDayNumber {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-weight: 500 !important;
          }
          .rdrDayHovered:not(.rdrDayDisabled) .rdrDayNumber {
            background: #f0e5da !important;
            color: #8E6448 !important;
            border-radius: 6px !important;
            font-weight: 600 !important;
          }
          .rdrDayStartPreview,
          .rdrDayEndPreview,
          .rdrDayInRange {
            background: #fff0e6 !important;
          }
          .rdrDayStartEdge,
          .rdrDayEndEdge,
          .rdrDayStart,
          .rdrDayEnd {
            background: #8E6448 !important;
            border-radius: 6px !important;
          }
          .rdrDayStart .rdrDayNumber,
          .rdrDayEnd .rdrDayNumber {
            color: #ffffff !important;
            font-weight: 600 !important;
          }
          .rdrDefinedRangesWrapper {
            border-right: 1px solid #e8d5c4 !important;
            padding-right: 16px !important;
            margin-right: 16px !important;
          }
          .rdrStaticRange {
            background: #f8f3ed !important;
            border: 1px solid #e8d5c4 !important;
            border-radius: 6px !important;
            color: #333333 !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
          }
          .rdrStaticRange:hover {
            background: #f0e5da !important;
            border-color: #d4c5b9 !important;
            color: #8E6448 !important;
          }
          .rdrStaticRangeLabel {
            color: #333333 !important;
            font-size: 13px !important;
          }
          .rdrStaticRange.active {
            background: #8E6448 !important;
            border-color: #8E6448 !important;
            color: #ffffff !important;
          }
          .rdrStaticRange.active .rdrStaticRangeLabel {
            color: #ffffff !important;
            font-weight: 600 !important;
          }
          .rdrNextPrevButton {
            background: #f0e5da !important;
            border: 1px solid #e8d5c4 !important;
            border-radius: 6px !important;
            width: 32px !important;
            height: 32px !important;
            padding: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            color: #8E6448 !important;
            font-weight: 600 !important;
          }
          .rdrNextPrevButton:hover {
            background: #8E6448 !important;
            color: #ffffff !important;
          }
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
          .ca-grid-wrap .nav-tabs .nav-link.active {
            color: #8E6448 !important;
            border-bottom: 2px solid #8E6448 !important;
            font-weight: 600 !important;
          }
          .ca-grid-wrap .nav-tabs .nav-link {
            color: #a07050 !important;
          }
        `}</style>
        <div className="filter-box mb-0">
          <div
            className="card ca-filter-card p-0 m-0"
            style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
          >
            <div className="ca-filter-body">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <label>From - To Date</label>
                    <ReactDatePicker
                      ref={this.refDateRangePicker}
                      calendarContainer={this.renderDateRangeCalendarContainer}
                      selectsRange={true}
                      startDate={
                        this.state.searchFromDate
                          ? moment(this.state.searchFromDate).toDate()
                          : null
                      }
                      endDate={
                        this.state.searchToDate
                          ? moment(this.state.searchToDate).toDate()
                          : null
                      }
                      onChange={([start, end]) => {
                        this.setState({
                          searchFromDate: start,
                          searchToDate: end,
                        });
                      }}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/dd/yyyy - MM/dd/yyyy"
                      onChangeRaw={(e) => e.preventDefault()}
                      className="dc-daterange-input"
                      wrapperClassName="dc-daterange-wrapper"
                      monthsShown={2}
                      showPopperArrow={false}
                      portalId="dc-daterange-portal"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <label>Employee Number</label>
                    <SelectBox
                      dataSource={this.state.dropdownCrewDataSource}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select Employee"
                      name="employeeNumber"
                      value={this.state.employeeNumber}
                      displayExpr="employeeName"
                      valueExpr="employeeNumber"
                      showClearButton={true}
                      searchEnabled={true}
                      onValueChanged={(e) => {
                        this.setState((prev) => ({
                          ...prev,
                          employeeNumber: e?.value ?? "",
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                  <br></br>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    onClick={this.handleSearchFeedback}
                  >
                    <span title="Submit">
                      <i className="fas fa-search"></i> Search
                    </span>
                  </button>
                  &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      window.history.replaceState({}, "");
                      this.setState((prev) => ({
                        ...prev,
                        hotelFeedbackGridDataSource: [],
                        transportFeedbackGridDataSource: [],
                        searchFromDate: moment(new Date())
                          .add(-30, "days")
                          .toDate(),
                        searchToDate: new Date(),
                        employeeNumber: "",
                        isShowImagePopup: false,
                        imagePopup: {
                          imageViewerTitle: "",
                          imageFileUrls: [],
                        },
                      }));
                    }}
                  >
                    <span title="Clear">
                      <i className="fas fa-eraser"></i> Clear
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="card ca-grid-wrap mt-0"
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        >
          <div className="card-body">
            <div>
              <ul
                className="nav nav-tabs mt-1 ml-2"
                id="custom-tabs-tab"
                role="tablist"
              >
                {/* <li className="nav-item d-none">
                  <a
                    className={`nav-link ${
                      this.state.selectedTabId === 3 ? "active" : ""
                    }`}
                    id="tabHotel"
                    data-toggle="pill"
                    href="#tabfeedbackhotel"
                    role="tab"
                    aria-selected={
                      this.state.selectedTabId === 3 ? "true" : "false"
                    } //"true"
                    onClick={async () => {
                      this.setState((prev) => ({ ...prev, selectedTabId: 3 }));
                      // await this.GetHotelFeedback();
                    }}
                  >
                    Hotel
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      this.state.selectedTabId === 1 ? "active" : ""
                    }`}
                    id="tabHotelTransport"
                    data-toggle="pill"
                    href="#tabfeedbackhotel"
                    role="tab"
                    aria-selected={
                      this.state.selectedTabId === 1 ? "true" : "false"
                    } //"false"
                    onClick={async () => {
                      this.setState((prev) => ({ ...prev, selectedTabId: 1 }));
                      await this.GetHotelFeedback();
                    }}
                  >
                    Hotel Shuttle{" "}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link ${
                      this.state.selectedTabId === 2 ? "active" : ""
                    }`}
                    id="tabLocalTransport"
                    data-toggle="pill"
                    href="#tabfeedbacktransport"
                    role="tab"
                    aria-selected={
                      this.state.selectedTabId === 2 ? "true" : "false"
                    } //"false"
                    onClick={async () => {
                      this.setState((prev) => ({ ...prev, selectedTabId: 2 }));
                      await this.GetTransportFeedback();
                    }}
                  >
                    Local Vendor{" "}
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="tab-content tab-bordered"
              id="custom-tabs-tabContent"
            >
              <div
                className={`tab-pane fade ${
                  this.state.selectedTabId === 1 ? "active show" : ""
                }`}
                id="tabfeedbackhotel"
                role="tabpanel"
              >
                <DataGrid
                  ref={this.refHotelGrid}
                  dataSource={this.state.hotelFeedbackGridDataSource}
                  showBorders={true}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  showRowLines={true}
                  showColumnLines={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async () => {
                          await this.GetHotelFeedback();
                        },
                      },
                    });
                  }}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#fff0e6";
                      e.cellElement.style.color = "#000000";
                    }
                    if (e.rowType === "data") {
                      if (e.column.dataField !== "id") {
                        if (e.data.issueStatusId === 4) {
                          e.cellElement.style.backgroundColor = "#9ACD32";
                        } else if (e.data.issueStatusId === 5) {
                          e.cellElement.style.backgroundColor = "#f57f85";
                        } else if (e.data.issueStatusId === 3) {
                          e.cellElement.style.backgroundColor = "#dff092";
                        } else if (e.data.issueStatusId === 2) {
                          e.cellElement.style.backgroundColor = "#f1df61";
                        }
                      }
                    }
                  }}
                >
                  <Column
                    dataField="id"
                    caption=""
                    allowSorting={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowFiltering={false}
                    fixed={true}
                    width={50}
                    cellRender={(data) => {
                      return (
                        <div style={{ textAlign: "center" }}>
                          <a
                            href="#"
                            title="Comment(s)"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleOnRedirectToComment(e, data.data);
                            }}
                          >
                            <i
                              style={{
                                cursor: "pointer",
                                marginLeft: "0px",
                              }}
                              className="fas fa-comment-dots"
                            />
                          </a>
                        </div>
                      );
                    }}
                    fixed={true}
                  />

                  <Column
                    dataField="airportCode"
                    caption="Airport"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={75}
                  />
                  <Column
                    dataField="employeeNumber"
                    caption="Employee #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={105}
                  />
                  <Column
                    dataField="crewFullName"
                    caption="Crew  Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="airlineCrewType"
                    caption=" Position"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="phoneNumber"
                    caption="Phone"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="email"
                    caption="Email"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="hotelName"
                    caption="Hotel"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={210}
                  />
                  <Column
                    dataField="transportationTime"
                    caption="Transportation Time"
                    dataType={"datetime"}
                    format={DateFormat.DateTime24WesternFormat}
                  />

                  <Column
                    dataField="flightType"
                    caption="Flight Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="flightNumber"
                    caption="Flight No"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={100}
                  />
                  <Column
                    dataField="flightTime"
                    caption="Flight Time"
                    dataType={"datetime"}
                    format={DateFormat.DateTime24WesternFormat}
                  />

                  <Column
                    dataField="isVehicleDelayed"
                    caption="Vehicle Delayed"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => (
                      <span>{data.value === true ? "Yes" : "No"}</span>
                    )}
                  />
                  <Column
                    dataField="vehicleDelayReason"
                    caption="Delay Reason"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />

                  <Column
                    dataField="crewArrivedAtPickupPoint"
                    caption="Time You Arrived At Pickup"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={220}
                  />

                  <Column
                    dataField="isVehicleArrivedBeforeCrewAtPickupPoint"
                    caption="Cab Post Arrived At Pickup"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => (
                      <span>{data.value === true ? "Yes" : "No"}</span>
                    )}
                  />
                  <Column
                    dataField="baseStation"
                    caption="Crew Base Station"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />

                  <Column
                    dataField="feedbackDescription"
                    caption="Feedback"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />

                  <Column
                    dataField="createdTime"
                    caption="Submission Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"datetime"}
                    width={140}
                    format={DateFormat.DateTime24WesternFormat}
                  />
                  <Paging defaultPageSize={10} />

                  <HeaderFilter visible={true} />
                  <Pager
                    displayMode="full"
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="HotelFeedback"
                  />
                </DataGrid>
              </div>
              <div
                className={`tab-pane fade ${
                  this.state.selectedTabId === 2 ? "active show" : ""
                }`}
                id="tabfeedbacktransport"
                role="tabpanel"
              >
                <DataGrid
                  ref={this.refTransportGrid}
                  dataSource={this.state.transportFeedbackGridDataSource}
                  showBorders={true}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  showRowLines={true}
                  showColumnLines={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async () => {
                          await this.GetTransportFeedback();
                        },
                      },
                    });
                  }}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#8E6448";
                      e.cellElement.style.color = "#ffffff";
                    }
                    if (e.rowType === "data") {
                      if (e.column.dataField !== "id") {
                        if (e.data.issueStatusId === 4) {
                          e.cellElement.style.backgroundColor = "#9ACD32";
                        } else if (e.data.issueStatusId === 5) {
                          e.cellElement.style.backgroundColor = "#f57f85";
                        } else if (e.data.issueStatusId === 3) {
                          e.cellElement.style.backgroundColor = "#dff092";
                        } else if (e.data.issueStatusId === 2) {
                          e.cellElement.style.backgroundColor = "#f1df61";
                        }
                      }
                    }
                  }}
                >
                  <Column
                    dataField="id"
                    caption=""
                    allowSorting={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowFiltering={false}
                    fixed={true}
                    width={25}
                    cellRender={(data) => {
                      let replyLink = (
                        <a
                          href="#"
                          title="Reply"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleOnRedirectToComment(e, data.data);
                          }}
                        >
                          <i
                            style={{
                              cursor: "pointer",
                              marginLeft: "0px",
                            }}
                            className="fas fa-comment-dots"
                          />
                        </a>
                      );
                      return (
                        <div style={{ textAlign: "center" }}>{replyLink}</div>
                      );
                    }}
                    fixed={true}
                  />

                  <Column
                    dataField="airportCode"
                    caption="Airport"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={75}
                  />
                  <Column
                    dataField="employeeNumber"
                    caption="Employee #"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={105}
                  />
                  <Column
                    dataField="crewFullName"
                    caption="Crew Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="phoneNumber"
                    caption="Phone"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="email"
                    caption="Email"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="airlineCrewType"
                    caption="Position"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />

                  <Column
                    dataField="baseStation"
                    caption=" Base Station"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="transporterName"
                    caption="Transporter"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={210}
                  />

                  <Column
                    dataField="transportationTime"
                    caption="Transportation Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"datetime"}
                    width={160}
                    format={DateFormat.DateTime24WesternFormat}
                  />
                  <Column
                    dataField="flightType"
                    caption="Flight Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={120}
                  />
                  <Column
                    dataField="flightNumber"
                    caption="Flight No"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={100}
                  />
                  <Column
                    dataField="flightTime"
                    caption="Flight Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"datetime"}
                    width={120}
                    format={DateFormat.DateTime24WesternFormat}
                  />

                  <Column
                    dataField="isVehicleDelayed"
                    caption="Vehicle Delayed"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => (
                      <span>{data.value === true ? "Yes" : "No"}</span>
                    )}
                  />
                  <Column
                    dataField="vehicleDelayReason"
                    caption="Delay Reason"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                  />
                  <Column
                    dataField="crewArrivedAtPickupPoint"
                    caption="Time You Arrived At Pickup"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={220}
                  />
                  <Column
                    dataField="isVehicleArrivedBeforeCrewAtPickupPoint"
                    caption="Cab Post Arrived At Pickup"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    cellRender={(data) => (
                      <span>{data.value === true ? "Yes" : "No"}</span>
                    )}
                  />
                  <Column
                    dataField="driverFeedback"
                    caption="Driver Feedback"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={250}
                  />
                  <Column
                    dataField="supervisorFeedback"
                    caption="Supervisor Feedback"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={250}
                  />

                  <Column
                    dataField="createdTime"
                    caption="Submission Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    dataType={"datetime"}
                    width={140}
                    format={DateFormat.DateTime24WesternFormat}
                  />

                  <Paging defaultPageSize={10} />
                  <Pager
                    displayMode="full"
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="TransportFeedback"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
        {this.state.isShowImagePopup && (
          <ImageViewerComponent
            onClose={this.handleOnImagePopupClose}
            imageViewerTitle={this.state.imagePopup.imageViewerTitle}
            imageFileUrl={this.state.imagePopup.imageFileUrls}
          />
        )}
      </>
    );
  }
}
